import { Injectable, inject } from '@angular/core';
import { ApiDataAccess, HttpApiQueryRepository, interpolate } from '@softline/core';
import { SOFTLINE_API_CLAIM_REPORT_DOCUMENT_QUERY } from '../claim-report.api';
import { ClaimReportTruckQueryRow } from '../types/claim-report-document-query';

@Injectable()
export class ClaimReportTruckRepository extends HttpApiQueryRepository<ClaimReportTruckQueryRow> {
  constructor() {
    super(
      inject(ApiDataAccess),
      interpolate(SOFTLINE_API_CLAIM_REPORT_DOCUMENT_QUERY, { documentType: 'SALES_ORDER' })
    );
  }
}
